module.exports = __webpack_public_path__ + "img/8.00f44c32.webp";